import React,{useState,useEffect,useRef} from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
  ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
  GripHorizontal,
  CopyPlus,
  Bookmark,
  Pencil,
  Trash2,
  Recycle,
  Paperclip,
  FileSliders,
  ImagePlus,
  FolderArchive,
  MonitorDot,
  CalendarDays} from 'lucide-react';
  import Snackbar from "../../../../Snackbar";

import { getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";

import contentfolder from "../../../contentImgs/folder.png";
import { addEntityToAnyEntity } from "../../../../store/actions/CreateContent/FolderAPI/ChapterAPI";
import QuizSetUpOuter from "../Quiz/QuizSetUpOuter";
const FolderContentPopUp =({closePopUp,item})=>{

     const dispatch = useDispatch();
        const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
              const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");
           const user = useSelector((state)=>state?.user?.user);
           const [FolderInputData ,setFolderInputData] =useState("")
           const [activeFilterOne, setActiveFilterOne] =useState(true);
           const [activeFilterTwo, setActiveFilterTwo] =useState(false);
           const [activeFilterThree, setActiveFilterThree] =useState(false);
           const [activeFilterFour, setActiveFilterFour] =useState(false);
           const [activeFilterASC, setActiveFilterASC] =useState(true);
           const [activeFilterDESC, setActiveFilterDESC] =useState(false);
               const [snackbarVisible, setSnackbarVisible] = useState(false);
                     const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                     const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                   
                              const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                   const showSnackbar = () => {
                     setSnackbarVisible(true);
                   };
                  
                   const hideSnackbar = () => {
                     setSnackbarVisible(false);
                   };
             
             
                        
                        
                     
                    const [animate, setAnimate] = useState(false);
      
       const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }




      
       const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     const appId = useSelector((state)=>state?.app?.app?.ID);
           const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
               
          
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemArrFolder, setItemArrFolder] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteFolderPopUp, setDeleteFolderPopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           const [openQuizPopUpContent, setopenQuizPopUpContent] = useState("");
           const [parentFolderItem, setParentFolderItem] = useState({});
            const [quizObject, setQuizObject] = useState({ID:""});
 const [folderItem ,setFolderItem] =useState({});
 const updateItemTitle = (ID, newTitle) => {
  const updatedItems = itemArr.map(item =>
    item?.ID === ID ? { ...item, Name :newTitle } : item
  
  ); 

 // console.log(updatedItems)
  setItemArr(updatedItems);
};
const sendBackFolder = (folder) => {
  const updatedItems = [...itemArr, folder]
  const updatedItemsMenuorder = [...itemReorderArr, {ID:folder?.ID,menuOrder:folder?.menuOrder}]
  setItemReorderArr( updatedItemsMenuorder);
 // console.log(updatedItems)
  setItemArr(updatedItems);
};

      useEffect((e)=>{
       
      
        },[visibility,orderBy,postIdCourse]);
       

           const fireGetAllContentsByFolderId=(folderItem)=>{
                   setItemArrFolder([])
                 
                 
                 setLoader({status:true});
                     
                       const apiData = dispatch(addEntityToAnyEntity({
                         token:AppToken,courseId:postIdCourse ,parentEntityType:"Folder",parentEntityId:folderItem?.contentID,postParent:folderItem?.contentID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                         appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken,visibility:visibility,orderBy:orderBy,editType:"getAllContents",
                         }));
                       /* get response as Promise   */
                       apiData.then(response => {
                 
                         if(response){
                          
                           if(response){
                         setResponseMessage(response?.message);
                         setSnackbarColor("rgba(144, 202, 249,1)");
                       
                         if(response)  {setItemArrFolder(response?.contents);
                           
                        
                         }else{setItemArrFolder([]);};
                    
                        }else{
                     
                     setSnackbarVisible(true);
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)
                        }
                           
                        
                        if(response?.logout){
                        
                         setResponseMessage("You are Logged Out!!!");
                           
                         setSnackbarColor("#958FDA");
                       
                     setLoader({status:false});
                     
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)
                         setTimeout(()=>{
                           dispatch({type:"LOGOUT"});
                     
                         },3000)
                         
                       }
                     /* resetting Login input Fields */
                     
                         }else{
                           setResponseMessage("Something Went Wrong...");
                           
                           setSnackbarColor("#958FDA");
                            
                       setLoader({status:false});
                       
                       setSnackbarVisible(true);
                       setTimeout(()=>{
                         
                         setSnackbarVisible(false);
                        
                          
                       },3000)    }
                     
                       }).catch(error => {
                      
                         //popup of error Info
                         setResponseMessage("Something Went Wrong...");
                           
                         setSnackbarColor("#958FDA");
                     setLoader({status:false});
                     
                     setSnackbarVisible(true);
                     setTimeout(()=>{
                       
                       setSnackbarVisible(false);
                      
                        
                     },3000)
                         console.error(error);
                       });
                  }

                  const fireGetQuizDataByQuizId=(quizObjectID)=>{
                     
                      setLoader({status:true});
                      
                        const apiData = dispatch(getQuizDataByQuizId({testName:"",type:"mock",
                          postParent:"",userEmail:user_email?user_email:"",
                          currentToken:currentToken?currentToken:"",
                          editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                          ));
                        /* get response as Promise   */
                        apiData.then(response => {
                          if(response){  
                            if(response?.quiz){
                              
                          setResponseMessage(response?.message);
                          setSnackbarColor("rgba(144, 202, 249,1)");
                        setQuizObject(response?.quiz)
                      
                      
                    
                         }else{
                          setResponseMessage("Something Went Wrong...");
                            
                          setSnackbarColor("#958FDA");
                       
                           
                      setLoader({status:false});
                      
                      setSnackbarVisible(true);
                      setTimeout(()=>{
                        
                        setSnackbarVisible(false);
                       
                         
                      },3000)
                         }
                            
                         
                         if(response?.logout){
                         
                          setResponseMessage("You are Logged Out!!!");
                            
                          setSnackbarColor("#958FDA");
                       
                           
                      setLoader({status:false});
                      
                      setSnackbarVisible(true);
                      setTimeout(()=>{
                        
                        setSnackbarVisible(false);
                       
                         
                      },3000)
                          setTimeout(()=>{
                            dispatch({type:"LOGOUT"});
                      
                          },3000)
                          
                        }
                      /* resetting Login input Fields */
                      
                          }else{
                            setResponseMessage("Something Went Wrong...");
                            
                            setSnackbarColor("#958FDA");
                         
                             
                        setLoader({status:false});
                        
                        setSnackbarVisible(true);
                        setTimeout(()=>{
                          
                          setSnackbarVisible(false);
                         
                           
                        },3000)    }
                      
                        }).catch(error => {
                       
                          //popup of error Info
                          setResponseMessage("Something Went Wrong...");
                            
                          setSnackbarColor("#958FDA");
                       
                           
                      setLoader({status:false});
                      
                      setSnackbarVisible(true);
                      setTimeout(()=>{
                        
                        setSnackbarVisible(false);
                       
                         
                      },3000)
                          console.error(error);
                        });
                       
                        }


                             const flattenedData = itemArr!=[]?Object.values(itemArr):'';
 const flattenedDataFolder = itemArrFolder!=[]?Object.values(itemArrFolder):'';

        const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';


         return (<>
    {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
       <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99,cursor:"pointer"}} onClick={()=>closePopUp(false)} className="appDesignPopUpOpacity"> </div>
        <div   className="AreYouSurePopUp" style={{height:"400px",borderRadius: '20px'}}> 
        <h2 align="center" >   You  Can See  <span className="coloredTextV1" >Folder Content  Here...</span> </h2>
      
 
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"280px",overflowX:"hidden"}}>
<div  className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",}}>
<div className="courseContentItemJustifyContentIcons">{<div></div>}
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px",paddingLeft:"5px"
    
   }}/> </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {item?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  {visibility=="public"?<div></div> :<div></div>}
{visibility=="public"?<div></div> :<div></div>}
<div></div>    
 </div>
  {visibility=="public"?openContentInFolder==item?.contentID?<ChevronDown onClick={()=>{setOpenContentInFolder("");fireGetAllContentsByFolderId(item)}}  onMouseEnter={handleMouseEnter}
 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
:<ChevronUp onClick={()=>{setOpenContentInFolder(item?.contentID);fireGetAllContentsByFolderId(item)}}  onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" style={{padding:"2px",cursor:"pointer"}}/> 
:""}</div>
{openContentInFolder?flattenedDataFolder?.length?flattenedDataFolder?.map((itemFolder, indexFolder) => 
        (<>{<div  index={indexFolder} key={itemFolder?.ID} style={{margin:"0px",marginTop:"10px",padding:"0px",paddingLeft:"0px",background:"#ffffff"}}   >
<div  className="courseContentItemOuterHeadActiveSettings" style={{margin:"10px",marginTop:"0px",padding:"10px",paddingLeft:"10px",background:" rgba(144, 202, 249,0.1)"}} >
<div className="courseContentItemJustifyContentIcons">
    { itemFolder?.postType=="Quiz"?<CalendarDays onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
       color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Video"?<Video onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
       color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Audio"?<AudioLines onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
       color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Pdf"?<FileSliders onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
       color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Image"?<ImagePlus onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
       color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Zip"?<FolderArchive onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
       color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :itemFolder?.postType=="Ppt"?<MonitorDot onMouseEnter={handleMouseEnter}
                 onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
       color="rgba(144, 202, 249,1)" style={{padding:"5px",background:"rgba(144, 202, 249,0.1)",borderRadius:"5px",cursor:"pointer",cursor: 'move',}}/> :<div></div>}
       
          
 </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {itemFolder?.menuOrder}:  {itemFolder?.postType=="Quiz"?"Quiz":""} -  {itemFolder?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInnTwo"
         style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
            <div></div>
            <div></div>
{visibility=="public"?<Pencil onClick={()=>{if(itemFolder?.postType=="Quiz"){fireGetQuizDataByQuizId(itemFolder?.contentID)}}} 
   onMouseEnter={handleMouseEnter}
             onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
   color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",
    fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>:<div></div> }

    
             </div>
          
          
     
 </div></div>}</>)):"":""}

</div></div>


  {quizObject?.ID?<QuizSetUpOuter quizObject={quizObject}  setQuizObjectDataBack={(data)=>{setQuizObject(data)}} closeQuizPopUp={()=>{setQuizObject("")}}/>:""}
   
       </>)

    }
       export default FolderContentPopUp;
